import React, { useState, useEffect } from 'react';
import { profileApi } from '../../../services/api';

export default function PersonalInfo({ profile, onRefresh }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        location: '',
        linkedin_url: '',
        github_url: '',
        portfolio_url: '',
        professional_summary: ''
    });
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        if (profile?.personalInfo) {
            setFormData(profile.personalInfo);
        }
    }, [profile]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage(null);
        try {
            await profileApi.updatePersonalInfo(formData);
            setMessage({ type: 'success', text: 'تم حفظ المعلومات الشخصية بنجاح!' });
            onRefresh('personal');
        } catch (err) {
            setMessage({ type: 'error', text: 'فشل في حفظ المعلومات الشخصية' });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">المعلومات الشخصية</h2>
            </div>

            <form onSubmit={handleSubmit} className="personal-form">
                <div className="form-grid">
                    <div className="form-group">
                        <label className="form-label">الاسم الكامل</label>
                        <input
                            type="text"
                            name="name"
                            className="form-input"
                            value={formData.name || ''}
                            onChange={handleChange}
                            placeholder="محمد أحمد"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">البريد الإلكتروني</label>
                        <input
                            type="email"
                            name="email"
                            className="form-input"
                            value={formData.email || ''}
                            onChange={handleChange}
                            placeholder="mohammed@example.com"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">رقم الهاتف</label>
                        <input
                            type="tel"
                            name="phone"
                            className="form-input"
                            value={formData.phone || ''}
                            onChange={handleChange}
                            placeholder="+966 50 123 4567"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">الموقع</label>
                        <input
                            type="text"
                            name="location"
                            className="form-input"
                            value={formData.location || ''}
                            onChange={handleChange}
                            placeholder="المدينة، الدولة"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">رابط LinkedIn</label>
                        <input
                            type="url"
                            name="linkedin_url"
                            className="form-input"
                            value={formData.linkedin_url || ''}
                            onChange={handleChange}
                            placeholder="https://linkedin.com/in/username"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">رابط GitHub</label>
                        <input
                            type="url"
                            name="github_url"
                            className="form-input"
                            value={formData.github_url || ''}
                            onChange={handleChange}
                            placeholder="https://github.com/username"
                        />
                    </div>
                    <div className="form-group full-width">
                        <label className="form-label">رابط معرض الأعمال</label>
                        <input
                            type="url"
                            name="portfolio_url"
                            className="form-input"
                            value={formData.portfolio_url || ''}
                            onChange={handleChange}
                            placeholder="https://yourportfolio.com"
                        />
                    </div>
                    <div className="form-group full-width">
                        <label className="form-label">الملخص المهني</label>
                        <textarea
                            name="professional_summary"
                            className="form-textarea"
                            value={formData.professional_summary || ''}
                            onChange={handleChange}
                            placeholder="ملخص مهني موجز يبرز مهاراتك وخبراتك الرئيسية..."
                            rows="4"
                        />
                    </div>
                </div>

                {message && (
                    <div className={`form-message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                <div className="form-actions">
                    <button type="submit" className="save-button" disabled={saving}>
                        {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
                    </button>
                </div>
            </form>
        </div>
    );
}
